import {
    UNIT_TYPE_EVENT_DELETE_OPEN_MODAL,
    UNIT_TYPE_EVENT_DELETE_REQUEST,
    UNIT_TYPE_EVENT_DELETE_RESULT,
} from 'Redux/actionTypes';

export const unitTypeEventDeleteOpenModal = (open, unitTypeEvents) => ({
    type: UNIT_TYPE_EVENT_DELETE_OPEN_MODAL,
    payload: { open, unitTypeEvents }
})

export const unitTypeEventDeleteRequest = (data) => ({
    type: UNIT_TYPE_EVENT_DELETE_REQUEST,
    payload: data
})

export const unitTypeEventDeleteResult = (data) => ({
    type: UNIT_TYPE_EVENT_DELETE_RESULT,
    payload: data
})